const KNOWN = (row) => typeof row?.sumDelta === 'number' && Number.isFinite(row.sumDelta)
  && row.totalDeltaState != null && !['absent', 'live', 'opening'].includes(row.totalDeltaState);

/** % change of the completed months' views growth (`sumDelta`): last vs the one before. Missing, live, opening-start or zero base → null. */
export function monthGrowthPct (last, base) {
  if (!KNOWN(last) || !KNOWN(base) || base.sumDelta === 0) return null;
  return ((last.sumDelta - base.sumDelta) / Math.abs(base.sumDelta)) * 100;
}

/** ▼ for a decline, ▲ otherwise. */
export function growthArrow (pct) {
  return pct < 0 ? '▼' : '▲';
}
